import type { ReactNode } from 'react';
import { Container, ContainerProps, Flex } from '@backyard-ui/core';

import styles from './Container.styles';

interface ContentProps {
  children: ReactNode;
  size?: ContainerProps['size'];
}

function Content(props: ContentProps) {
  const { children, size = '6xl' } = props;

  return (
    <Container size={size} className={styles()}>
      <Flex align="center" justify="space-between" wrap="wrap">
        {children}
      </Flex>
    </Container>
  );
}

export default Content;
